import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export type QrCodeState = 'loading' | 'ready' | 'error';

interface QrCodeImageProps {
  value: string;
  size?: number;
  className?: string;
  alt?: string;
  onStateChange?: (state: QrCodeState) => void;
}

export default function QrCodeImage({ value, size = 256, className, alt = 'QR Code de cadastro', onStateChange }: QrCodeImageProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setDataUrl(null);
    onStateChange?.('loading');

    QRCode.toDataURL(value, { width: size, margin: 1 })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) {
          setDataUrl(null);
          onStateChange?.('error');
        }
      });
    return () => {
      cancelled = true;
    };
  }, [value, size, onStateChange]);

  if (!dataUrl) {
    return <div className={className} style={{ width: size, height: size }} aria-hidden="true" />;
  }

  return (
    <img
      src={dataUrl}
      alt={alt}
      width={size}
      height={size}
      className={className}
      onLoad={() => onStateChange?.('ready')}
      onError={() => onStateChange?.('error')}
    />
  );
}
